// DemoButton Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IntlMessage from '../intl/intl_message.jsx'

class DemoButton extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isVisible: true
    }
  }

  static get propTypes () {
    return {
      onClick: PropTypes.func,
      title: PropTypes.string,
      icon: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      onClick: null,
      title: '',
      icon: 'button-register'
    }
  }

  show () {
    this.setState({ isVisible: true })
  }

  hide () {
    this.setState({ isVisible: false })
  }

  render () {
    const { onClick, title, icon } = this.props
    const { isVisible } = this.state

    return (
      <div
        className={`demo-button${isVisible ? '' : ' hidden'}`}
        onClick={onClick}
      >
        <i className={`icon icon-${icon}`} />
        <span className='info'>
          <IntlMessage ident={title} />
        </span>
      </div>
    )
  }
}

export default DemoButton
